// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-animation-wrapper[data-v-8494e59a]{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center;transition:all .3s}", ""]);
// Exports
module.exports = exports;
